import { initialStateFormCampaignContext } from '@/constants/InitialState'
import { FormCampaignProps } from '@/models/FormCampaignProps'
import React, { createContext, useState } from 'react'

export type FormCampaignContextType = {
  ctx: FormCampaignProps;
  saveCtx: (ctx: FormCampaignProps) => void;
};

export const FormCampaignContext = createContext<FormCampaignContextType | null>(null)

export const FormCampaignProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ctx, setCtx] = useState<FormCampaignProps>(initialStateFormCampaignContext)

  const saveCtx = (_ctx: FormCampaignProps) => {
    setCtx(_ctx)
  }

  return <FormCampaignContext.Provider value={{ ctx, saveCtx }}>{children}</FormCampaignContext.Provider>
}
